<div class="app-logo">
  <img src="assets/logo.png" alt="LeuPRO Logix logo" />
  <span class="body-small"> Cipla Orders Management System </span>
</div>
